module.exports = __webpack_public_path__ + "img/linkedin.1fd63808.png";